import { createAction, props } from '@ngrx/store';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { ScheduleDetailSaveModel } from '../../schedule-details/models/schedule-detail-save.model';
import { SchedulesFilterOption } from '../models/schedule-filter-option';
import { ScheduleRegisterListItem } from '../models/schedule-register-results.model';

const area = 'Schedule Register';

export const scheduleRegisterAdapterActions = createRegisterActions<ScheduleRegisterListItem>(area);

export const scheduleRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: SchedulesFilterOption[] }>()
);

export const loadScheduleSuccess = createAction(`[${area}] Load Schedule Success`);

export const loadScheduleFailure = createAction(`[${area}] Load Schedule Failure`);

export const createSchedule = createAction(`[${area}] Create Schedule`);

export const setSelectedScheduleId = createAction(`[${area}] Set Selected ID`, props<{ scheduleId: number }>());

export const refreshList = createAction(`[${area}] Refresh List`);

export const saveScheduleAs = createAction(`[${area}] Save As`, props<{ schedule: ScheduleRegisterListItem }>());

export const saveScheduleAsConfirmed = createAction(
   `[${area}] Save As Confirmed`,
   props<{ schedule: ScheduleDetailSaveModel }>()
);

export const saveScheduleAsCanceled = createAction(`[${area}] Save As Canceled`);

export const loadingUrlParams = createAction(`[${area}] Loading URL Params`);

export const loadedUrlParams = createAction(`[${area}] Loaded URL Params`, props<{ scheduleId: number | null }>());
